import { dynamicLoader } from '~/utils';

export const ContactActivityEditor = dynamicLoader({
  name: 'ContactActivityEditorWrapper',
  importFunc: () => import('./contact-activity-editor-wrapper'),
});

export { ContactActivityEditForm } from './contact-activity-edit-form';
